import { RoomRoofHeatLossDetailsFormModel } from '../../quote-or-design-form/rooms/heatLoss/roomRoofHeatLossDetailsFormModel';

export type RoomRoofHeatLossDetailsResponse = {
  displayIndex: number;
  maximumVaultHeightInMetres: number | null;
  roomAreaCoveredPercentage: number | null;
  additionalRoomVolumeInMetresCubed: number | null;
  skylightAreaInMetresSquared: number | null;
  temperatureAboveInDegreesCelsius: number | null;
};

export const mapRoomRoofHeatLossDetailsResponseToFormModel = (
  response: RoomRoofHeatLossDetailsResponse,
): RoomRoofHeatLossDetailsFormModel => ({
  maximumVaultHeightInMetres: response.maximumVaultHeightInMetres?.toString() ?? '',
  roomAreaCoveredPercentage: response.roomAreaCoveredPercentage?.toString() ?? '',
  additionalRoomVolumeInMetresCubed: response.additionalRoomVolumeInMetresCubed?.toString() ?? '',
  skylightAreaInMetresSquared: response.skylightAreaInMetresSquared?.toString() ?? '',
  temperatureAboveInDegreesCelsius: response.temperatureAboveInDegreesCelsius?.toString() ?? '',
});
